/*
 * VT — store reviews: lightbox + "write a review" form toggle.
 * Opens a review photo full-size on click/tap; closes on backdrop click,
 * the close button, or Escape. No external dependencies.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('.vt-reviews').forEach(function (section) {
      initReviewsLightbox(section);
      initReviewForm(section);
    });
  });

  function initReviewsLightbox(section) {
    var lightbox = section.querySelector('.vt-reviews__lightbox');
    if (!lightbox) return;

    var img = lightbox.querySelector('.vt-reviews__lightbox-img');
    var closeBtn = lightbox.querySelector('.vt-reviews__lightbox-close');
    var lastFocused = null;

    function open(src, alt) {
      lastFocused = document.activeElement;
      img.src = src;
      img.alt = alt || '';
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      img.src = '';
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    section.querySelectorAll('[data-vt-lightbox-src]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        open(trigger.dataset.vtLightboxSrc, trigger.dataset.vtLightboxAlt);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) close();
    });
  }

  function initReviewForm(section) {
    var btn = section.querySelector('.vt-reviews__write-btn');
    var panel = section.querySelector('.vt-reviews__form-panel');
    if (!btn || !panel) return;

    function sync() {
      btn.setAttribute('aria-expanded', String(!panel.hidden));
    }

    // If the page just reloaded after a successful submission, the panel
    // is server-rendered visible (not hidden) so the thank-you message is
    // seen immediately — sync the button state and scroll it into view.
    sync();
    if (!panel.hidden && panel.querySelector('.vt-reviews__form-success')) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    btn.addEventListener('click', function () {
      panel.hidden = !panel.hidden;
      sync();
      if (!panel.hidden) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var firstField = panel.querySelector('input, select, textarea');
        if (firstField) firstField.focus();
      }
    });
  }
})();
